import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { GoogleSignInButton } from "../components/GoogleSignInButton";

export const Login = () => {
    const { login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Καλώς ήρθες πίσω!");
            navigate(location.state?.from || "/");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Σφάλμα σύνδεσης");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mx-auto max-w-md px-4 sm:px-8 py-20" data-testid="login-page">
            <h1 className="headline text-4xl mb-2">Σύνδεση</h1>
            <p className="text-white/60 mb-8 text-sm">Συνδέσου με Google ή με τον λογαριασμό σου.</p>

            <GoogleSignInButton />

            <div className="flex items-center gap-3 my-6">
                <div className="flex-1 h-px bg-white/10" />
                <span className="text-xs uppercase tracking-widest text-white/40">ή</span>
                <div className="flex-1 h-px bg-white/10" />
            </div>

            <form onSubmit={submit} className="space-y-4">
                <input
                    type="email"
                    required
                    data-testid="login-email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-[#16161a] border border-white/15 px-4 py-3 focus:outline-none focus:border-brand-red rounded-sm"
                />
                <input
                    type="password"
                    required
                    data-testid="login-password"
                    placeholder="Κωδικός"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full bg-[#16161a] border border-white/15 px-4 py-3 focus:outline-none focus:border-brand-red rounded-sm"
                />
                <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full">
                    {loading ? "Σύνδεση..." : "Σύνδεση με Email"}
                </button>
            </form>
            <p className="text-sm text-white/60 mt-6">
                Δεν έχεις λογαριασμό; <Link to="/register" className="text-brand-red hover:underline">Εγγράψου</Link>
            </p>
        </div>
    );
};
